import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconLock,
  IconBox,
  IconCircleDashedCheck,
  IconJumpRope,
  IconShieldCheck,
} from '@tabler/icons-react'

export const modulesModuleKey = 'modules'
export const rolesModuleKey = 'roles'
export const rolePermissionsModuleKey = 'permissions'
export const rolesAndPermissionsModuleKey = rolePermissionsModuleKey

const modulesRoute: RouteConfig = {
  uid: modulesModuleKey,
  path: 'permissions/modules',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/modules')).default,
  }),
}

const rolesRoute: RouteConfig = {
  uid: rolesModuleKey,
  path: 'permissions/roles',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/roles')).default,
  }),
}

const rolePermissionsRoute: RouteConfig = {
  uid: rolePermissionsModuleKey,
  path: 'permissions/role-permissions',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/role-permissions')).default,
  }),
}

const createRolePermissionsRoute: RouteConfig = {
  uid: rolePermissionsModuleKey,
  path: 'permissions/role-permissions/create',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/role-permissions/create'))
      .default,
  }),
}

const editRolePermissionsRoute: RouteConfig = {
  uid: rolePermissionsModuleKey,
  path: 'permissions/role-permissions/:id',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/role-permissions/edit'))
      .default,
  }),
}

const rolesAndPermissionsRoute: RouteConfig = {
  uid: rolesAndPermissionsModuleKey,
  path: 'permissions/roles-and-permissions',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/permissions/roles-and-permissions'))
      .default,
  }),
}

const detailRolesAndPermissionsRoute: RouteConfig = {
  uid: rolesAndPermissionsModuleKey,
  path: 'permissions/roles-and-permissions/:id',
  type: 'retrieve',
  lazy: async () => ({
    Component: (
      await import('@/pages/permissions/roles-and-permissions/detail')
    ).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Permissions',
  href: 'permissions',
  icon: <IconLock size={18} />,
  order: 18,
  sub: [
    {
      uid: modulesModuleKey,
      title: 'Modules',
      href: 'permissions/modules',
      icon: <IconBox size={18} />,
      order: 1,
    },
    {
      uid: rolesModuleKey,
      title: 'Roles',
      href: 'permissions/roles',
      icon: <IconCircleDashedCheck size={18} />,
      order: 2,
    },
    {
      uid: rolePermissionsModuleKey,
      title: 'Role Permissions',
      href: 'permissions/role-permissions',
      icon: <IconJumpRope size={18} />,
      order: 3,
    },
    {
      uid: rolesAndPermissionsModuleKey,
      title: 'Roles & Permissions',
      href: 'permissions/roles-and-permissions',
      icon: <IconShieldCheck size={18} />,
      order: 4,
    },
  ],
}

export default [
  modulesRoute,
  rolesRoute,
  rolePermissionsRoute,
  createRolePermissionsRoute,
  editRolePermissionsRoute,
  rolesAndPermissionsRoute,
  detailRolesAndPermissionsRoute,
]
